import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Donate } from "../components/campaign/Donate";
import { Footer } from "../components/campaign/Footer";

export default function DonatePage() {
  return (
    <div className="grain relative bg-white min-h-screen" data-testid="donate-page">
      <header className="border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <Link
            to="/"
            className="font-display font-extrabold tracking-tight text-lg text-slate-900 flex items-center gap-2"
            data-testid="donatepage-wordmark"
          >
            <span className="h-2.5 w-2.5 rounded-full bg-teal-600" />
            NOMAN&nbsp;ZAHEER
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-teal-700 transition-colors"
            data-testid="donatepage-back"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>
        </div>
      </header>

      <main>
        <Donate />
      </main>

      <Footer />
    </div>
  );
}
